import { useRef } from "react";
import { IconButton } from "@mui/material";
import { useTranslation } from "next-i18next";
import { useExtendedSearchDownloadMutation } from "src/api/client/extended-search.api";
import { IconDownload } from "src/components/icons-mui/download";
import { ToastStatus, useWfToast } from "src/hooks/use-wf-toast";
import { useRouterLocale } from "src/utils/router/use-router-locale";
import { getSearchState } from "../../store/search-store";
import { getMappedStore } from "../../store/utils";

export interface IDownloadButton {
    userNumOfDownloads: number;
}

export const DownloadButton = ({ userNumOfDownloads }: IDownloadButton) => {
    const downloads = useRef(userNumOfDownloads);
    const toastVisible = useRef(false);
    const toast = useWfToast();
    const { t } = useTranslation(["extended-search", "common"]);
    const searchMutation = useExtendedSearchDownloadMutation();
    const { country } = useRouterLocale();

    const onError = (title: string) => {
        if (!toastVisible.current) {
            toastVisible.current = true;
            toast({ status: ToastStatus.Error, duration: 5000, title: title });
            setTimeout(() => {
                toastVisible.current = false;
            }, 5000);
        }
    };

    const onDownloadClick = async () => {
        if (downloads.current < 5) {
            try {
                await searchMutation({
                    country,
                    ...getMappedStore(getSearchState()),
                });
                downloads.current++;
            } catch {
                onError(t("general-error", { ns: "common" }));
            }
        } else {
            onError(t("download-limit-reached"));
        }
    };

    return (
        <IconButton
            onClick={onDownloadClick}
            variant="outlined"
            size="small"
            sx={{ display: ["none", "none", "inline-flex"] }}
            aria-label={t("buttons.download")}
        >
            <IconDownload sx={{ width: 24, height: 24 }} />
        </IconButton>
    );
};
